import { useState } from 'react';
import { BanknoteArrowDown, TrendingUp, Users } from 'lucide-react';
import Header from './components/Header/Header';
import StatCard from './components/StatCard/StatCard';
import TraderTable from './components/TraderTable/TraderTable';
import ReturnCalculator from './components/ReturnCalculator/ReturnCalculator';
import Footer from './components/Footer/Footer';
import { useLeaderboard } from './hooks/useLeaderboard';
import { formatAum, formatCurrency, formatNumber } from './utils/format';
import styles from './App.module.css';

// The board is a top-15 board on every viewport — no pagination.
const TOP_TRADERS = 15;

function App() {
  const [sort, setSort] = useState(null);

  const { data, loading, error } = useLeaderboard({
    limit: TOP_TRADERS,
    sortBy: sort ? sort.key : null,
    sortDir: sort ? sort.direction : null,
  });

  function handleSort(key) {
    setSort((current) =>
      current && current.key === key && current.direction === 'desc'
        ? { key, direction: 'asc' }
        : { key, direction: 'desc' }
    );
  }

  // Placeholder until the platform totals arrive, matching the portal's "—".
  const show = (format, value) => (data ? format(value) : '—');

  const stats = [
    { label: 'Total AUM', value: show(formatAum, data?.totalAum), icon: TrendingUp },
    { label: 'Active accounts', value: show(formatNumber, data?.activeAccounts), icon: Users },
    { label: 'Net withdrawals', value: show(formatCurrency, data?.netWithdrawals), icon: BanknoteArrowDown },
  ];

  return (
    <div className="container">
      <Header />

      <main>
        <h1 className={`${styles.title} mt-4`}>Leaderboard</h1>
        <p className={`${styles.subtitle} mt-2 mb-0`}>
          Track the performance of every trader on the platform.
        </p>

        <div className="row g-3 mt-3">
          {stats.map((stat) => (
            <div key={stat.label} className="col-12 col-md-4">
              <StatCard {...stat} />
            </div>
          ))}
        </div>

        <h2 className={`${styles.sectionTitle} mt-5 mb-3`}>Traders</h2>
        <TraderTable
          traders={data?.traders ?? []}
          loading={loading}
          error={error}
          sort={sort}
          onSort={handleSort}
        />

        <div className="my-5 py-4">
          <ReturnCalculator />
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default App;
